import $ from "jquery";
import { toggleBodyScroll } from "../utils";
$(() => {
  $(".page-header .button-open").on("click", ({ currentTarget }) => {
    const button = $(currentTarget);
    toggleBodyScroll();
    $("header .nav").slideToggle();
  });
  $(".page-header .button-close").on("click", ({ currentTarget }) => {
    const button = $(currentTarget);
    toggleBodyScroll();
    $("header .nav").slideToggle();
  });
});
